/* eslint-disable react/jsx-props-no-spreading */

import type { IconProps } from "@chakra-ui/react";
import { Box, Icon, createIcon } from "@chakra-ui/react";
import React, { Fragment } from "react";

function IconBox({
  props,
  children,
}: {
  props: IconProps;
  children: React.ReactNode | React.ReactNode[];
}) {
  const defaultIconProps: IconProps = {
    viewBox: "0 0 24 24",
    strokeWidth: "1.25",
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    boxSize: 4,
  };
  return (
    <Icon {...defaultIconProps} {...props}>
      {children}
    </Icon>
  );
}

export const IconPlus = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </IconBox>
);
export const IconCirclePlus = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
    <path d="M9 12l6 0"></path>
    <path d="M12 9l0 6"></path>
  </IconBox>
);

export const IconMinus = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </IconBox>
);

export const IconSelector = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <polyline points="8 9 12 5 16 9"></polyline>
    <polyline points="16 15 12 19 8 15"></polyline>
  </IconBox>
);

export const IconInfo = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <circle cx="12" cy="12" r="9"></circle>
    <line x1="12" y1="8" x2="12.01" y2="8"></line>
    <polyline points="11 12 12 12 12 16 13 16"></polyline>
  </IconBox>
);

export const IconWarning = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M12 9v2m0 4v.01"></path>
    <path d="M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"></path>
  </IconBox>
);

export const IconReport = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697"></path>
    <path d="M18 14v4h4"></path>
    <path d="M18 11v-4a2 2 0 0 0 -2 -2h-2"></path>
    <rect x="8" y="3" width="6" height="4" rx="2"></rect>
    <circle cx="18" cy="18" r="4"></circle>
    <path d="M8 11h4"></path>
    <path d="M8 15h3"></path>
  </IconBox>
);

export const IconHand = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M8 13v-7.5a1.5 1.5 0 0 1 3 0v6.5"></path>
    <path d="M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5"></path>
    <path d="M14 5.5a1.5 1.5 0 0 1 3 0v6.5"></path>
    <path d="M17 7.5a1.5 1.5 0 0 1 3 0v8.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"></path>
  </IconBox>
);

// export const IconAnnotation = createIcon({
//   viewBox: "0 0 24 24",
//   path: (
//     <g fill="none" stroke="currentColor" strokeWidth={2}>
//       <path
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
//       />
//       <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
//       <path d="M12 20l-3 -3h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-2l-3 3"></path>
//       <line x1="8" y1="9" x2="16" y2="9"></line>
//       <line x1="8" y1="13" x2="14" y2="13"></line>
//     </g>
//   ),
// });
export const IconAnnotation = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M12 20l-3 -3h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-2l-3 3"></path>
    <line x1="8" y1="9" x2="16" y2="9"></line>
    <line x1="8" y1="13" x2="14" y2="13"></line>
  </IconBox>
);

export const IconTimeline = createIcon({
  viewBox: "0 0 48 48",
  path: (
    <g fill="currentColor">
      <path d="M42,29H20.8c-0.5,0-1-0.2-1.4-0.6l-3.7-3.7c-0.4-0.4-0.4-1,0-1.4l3.7-3.7c0.4-0.4,0.9-0.6,1.4-0.6H42 c0.6,0,1,0.4,1,1v8C43,28.6,42.6,29,42,29z" />
      <rect x="9" y="6" width="2" height="36" />
      <g>
        <circle cx="10" cy="10" r="3" />
        <circle cx="10" cy="24" r="3" />
        <circle cx="10" cy="38" r="3" />
      </g>
      <path d="M34,43H20.8c-0.5,0-1-0.2-1.4-0.6l-3.7-3.7c-0.4-0.4-0.4-1,0-1.4l3.7-3.7c0.4-0.4,0.9-0.6,1.4-0.6H34 c0.6,0,1,0.4,1,1v8C35,42.6,34.6,43,34,43z" />
      <path d="M35,15H20.8c-0.5,0-1-0.2-1.4-0.6l-3.7-3.7c-0.4-0.4-0.4-1,0-1.4l3.7-3.7C19.8,5.2,20.3,5,20.8,5H35 c0.6,0,1,0.4,1,1v8C36,14.6,35.6,15,35,15z" />
    </g>
  ),
});

export function IconProject(props: any): JSX.Element {
  return (
    <Box style={{ transform: "rotate(-90deg)" }}>
      <IconProjectRaw {...props} />
    </Box>
  );
}

export const IconProjectRaw = createIcon({
  viewBox: "0 0 1024 1024",
  path: (
    <g fill="currentColor" stroke="currentColor" strokeWidth={2}>
      <path d="M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8zm216-432H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" />
    </g>
  ),
});

export const IconLock = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <rect x="5" y="11" width="14" height="10" rx="2"></rect>
    <circle cx="12" cy="16" r="1"></circle>
    <path d="M8 11v-4a4 4 0 0 1 8 0v4"></path>
  </IconBox>
);

export const IconBot = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M7 7h10a2 2 0 0 1 2 2v1l1 1v3l-1 1v3a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-3l-1 -1v-3l1 -1v-1a2 2 0 0 1 2 -2z"></path>
    <path d="M10 16h4"></path>
    <circle cx="8.5" cy="11.5" r=".5" fill="currentColor"></circle>
    <circle cx="15.5" cy="11.5" r=".5" fill="currentColor"></circle>
    <path d="M9 7l-1 -4"></path>
    <path d="M15 7l1 -4"></path>
  </IconBox>
);

export const IconAddSection = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <line x1="9" y1="12" x2="15" y2="12"></line>
    <line x1="12" y1="9" x2="12" y2="15"></line>
    <path d="M4 6v-1a1 1 0 0 1 1 -1h1m5 0h2m5 0h1a1 1 0 0 1 1 1v1m0 5v2m0 5v1a1 1 0 0 1 -1 1h-1m-5 0h-2m-5 0h-1a1 1 0 0 1 -1 -1v-1m0 -5v-2m0 -5"></path>
  </IconBox>
);

export const IconNotes = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <rect x="5" y="3" width="14" height="18" rx="2"></rect>
    <line x1="9" y1="7" x2="15" y2="7"></line>
    <line x1="9" y1="11" x2="15" y2="11"></line>
    <line x1="9" y1="15" x2="13" y2="15"></line>
  </IconBox>
);

export const IconCanary = createIcon({
  viewBox: "0 0 64 64",
  path: (
    <path
      d="M11.3835616,3 C12.6999664,3 13.7671233,3.97822716 13.7671233,5.18493151 L13.7655342,5.12136986 L30.6089343,12.1267083 C31.0279557,11.6673359 31.6490444,11.3681701 32.3469287,11.3440435 L32.4383562,11.3424658 C33.7547609,11.3424658 34.8219178,12.3206929 34.8219178,13.5273973 C34.8219178,14.2855605 34.4006561,14.953532 33.7609901,15.3453594 L40.8765416,30.0604866 C41.5892868,30.1978837 42.184785,30.6271807 42.5073045,31.2056235 L48.1913256,31.2056235 C48.5858221,30.498089 49.388735,30.0136986 50.3150685,30.0136986 C51.631473,30.0136986 52.6986301,30.9919258 52.6986301,32.1986301 C52.6986301,32.8206611 52.4150665,33.3819814 51.9599703,33.7798959 L53.7302193,37.9695754 C54.935327,38.0786519 55.8767123,39.0104689 55.8767123,40.1438356 C55.8767123,41.35054 54.8095552,42.3287671 53.4931507,42.3287671 C52.421027,42.3287671 51.51423,41.679908 51.2146056,40.7872154 L47.5509315,39.5606575 L47.2577132,40.210529 C47.6549591,40.5853526 47.9067992,41.0903636 47.9297857,41.6490682 L47.9315068,41.7328767 C47.9315068,42.939581 46.86435,43.9178082 45.5479452,43.9178082 C45.0615029,43.9178082 44.6090949,43.7842338 44.2319906,43.5549153 L27.4109745,50.2746166 C27.1790127,50.6902259 26.8060995,51.0287711 26.3500388,51.2372652 L26.2351207,53.4354505 C26.8623855,53.8290329 27.2739726,54.4903192 27.2739726,55.239726 C27.2739726,56.4464303 26.2068157,57.4246575 24.890411,57.4246575 C24.3278088,57.4246575 23.8107322,57.2459826 23.4030282,56.947159 L17.7287977,59.0256554 C17.6132156,60.1335587 16.5950727,61 15.3561644,61 C14.0397596,61 12.9726027,60.0217728 12.9726027,58.8150685 C12.9726027,57.738393 13.8221667,56.8436084 14.9403206,56.6632741 L24.577341,34.290397 C24.0410984,33.8897521 23.6986301,33.2794823 23.6986301,32.5958904 C23.6986301,32.1425534 23.8492453,31.721463 24.1071081,31.3723729 L11.1504724,7.35954883 C9.94345832,7.25216584 9,6.31954541 9,5.18493151 C9,3.97822716 10.0671569,3 11.3835616,3 Z M24.5853151,39.9587123 L17.3372782,56.7545557 L22.5451646,54.847422 C22.690401,54.1130669 23.2360342,53.5065291 23.9672758,53.224698 L24.0769275,51.1632858 C23.3749498,50.7830895 22.9041096,50.0823589 22.9041096,49.2808219 C22.9041096,48.4246144 23.4413697,47.6834336 24.2237173,47.3251048 L24.5853151,39.9587123 Z M27.2036575,34.8821233 L26.5488261,47.4264384 C26.788957,47.563956 27.0004498,47.7395772 27.1732311,47.9440681 L42.4012005,41.8633712 L27.2036575,34.8821233 Z M32.2361507,17.3041507 L27.8823331,31.1637088 C28.2457617,31.5472192 28.4657534,32.0480048 28.4657534,32.5958904 C28.4657534,32.6589303 28.462841,32.7213465 28.4571327,32.7830323 L42.7699041,39.2833699 L40.4459315,34.3823699 L40.3835616,34.3835616 C39.097771,34.3835616 38.04977,33.4503044 38.0017212,32.2824387 L38,32.1986301 C38,31.592769 38.2690126,31.0445032 38.7035185,30.6487255 L32.2361507,17.3041507 Z M47.9271377,33.4341913 L42.5073151,33.4341096 L45.3131644,39.2368904 L47.9271377,33.4341913 Z M50.142468,34.9846432 L48.9060439,37.7124607 L51.6809729,38.6430442 L50.142468,34.9846432 Z M13.7723813,7.53049115 L25.7969589,29.8206301 L30.4988035,14.7976932 C30.397812,14.668354 30.3118344,14.5284926 30.2432057,14.3802493 L13.7723813,7.53049115 Z"
      id="canary"
      fill="currentColor"
    />
  ),
});

export const IconBack = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <polyline points="15 6 9 12 15 18"></polyline>
  </IconBox>
);

export const IconCheckCircle = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <circle cx="12" cy="12" r="9"></circle>
    <path d="M9 12l2 2l4 -4"></path>
  </IconBox>
);

export const IconCheck = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M5 12l5 5l10 -10"></path>
  </IconBox>
);

export const IconHourGlass = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M6.5 7h11"></path>
    <path d="M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"></path>
    <path d="M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z"></path>
  </IconBox>
);

export const IconGlobe = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <circle cx="12" cy="12" r="9"></circle>
    <line x1="3.6" y1="9" x2="20.4" y2="9"></line>
    <line x1="3.6" y1="15" x2="20.4" y2="15"></line>
    <path d="M11.5 3a17 17 0 0 0 0 18"></path>
    <path d="M12.5 3a17 17 0 0 1 0 18"></path>
  </IconBox>
);

export const IconTheme = createIcon({
  displayName: "ThemeIcon",
  viewBox: "0 0 24 24",
  path: (
    <Fragment>
      <path
        d="M7.15295406,8.31752034 C6.88190113,9.12110329 6.73503791,9.98147307 6.73503791,10.8761446 C6.73503791,15.2944226 10.3167599,18.8761446 14.7350379,18.8761446 C16.4389752,18.8761446 18.0184908,18.3434319 19.3161247,17.4354666 C18.2493894,20.5987159 15.2581746,22.8761446 11.7350379,22.8761446 C7.31675991,22.8761446 3.73503791,19.2944226 3.73503791,14.8761446 C3.73503791,12.1622404 5.08640966,9.7639659 7.15295406,8.31752034 Z M5.74322515,11.2532285 L5.72817491,11.2789678 C5.08943898,12.3443603 4.73503791,13.5801682 4.73503791,14.8761446 C4.73503791,18.7421378 7.86904466,21.8761446 11.7350379,21.8761446 C13.6934268,21.8761446 15.4963769,21.0645298 16.7828893,19.7271766 L16.8852252,19.6152285 L16.7918311,19.6398135 C16.2361916,19.76972 15.6649966,19.8472345 15.0844433,19.8694641 L14.7350379,19.8761446 C9.94199526,19.8761446 6.02405527,16.1293847 5.75031599,11.404963 L5.74322515,11.2532285 Z"
        id="moon"
        className="theme-icon moon"
        transform="translate(11.525581, 15.596832) rotate(-15.000000) translate(-11.525581, -15.596832) "
      />
      <path
        d="M19.8166914,12.9494439 C19.8907845,13.2259632 19.7302185,13.5092442 19.4580571,13.5821696 C19.1858957,13.655095 18.905201,13.4900495 18.8311079,13.2135302 C17.7197108,9.06573985 13.5092896,6.59005746 9.42686886,7.6839388 C8.78817156,7.85507722 8.18261616,8.10542507 7.61962931,8.42851894 C7.3749996,8.56891008 7.06285473,8.48075063 6.92243425,8.2316093 C6.78201376,7.98246798 6.86649203,7.66668952 7.11112175,7.52629839 C7.74943643,7.15997444 8.43569038,6.87626432 9.15855388,6.68257363 C13.7852974,5.44284145 18.5571081,8.24861483 19.8166914,12.9494439 Z M22.8411516,8.90069137 C22.943021,9.12949365 22.8885342,9.38176892 22.7225231,9.5029674 L22.6551288,9.54197075 L20.6009997,10.456528 C20.3836591,10.5532942 20.1145657,10.4230728 19.9999627,10.1656702 C19.8980933,9.9368679 19.9525801,9.68459264 20.1185912,9.56339416 L20.1859854,9.52439081 L22.2401146,8.60983357 C22.4574552,8.51306732 22.7265486,8.64328879 22.8411516,8.90069137 Z M7.91882991,2.97718102 L7.95783326,3.04457529 L8.8723905,5.09870448 C8.96915675,5.31604504 8.83893528,5.58513846 8.58153271,5.69974147 C8.35273042,5.80161082 8.10045516,5.74712401 7.97925668,5.58111297 L7.94025333,5.51371869 L7.02569609,3.4595895 C6.92892984,3.24224895 7.05915131,2.97315552 7.31655388,2.85855251 C7.54535617,2.75668317 7.79763143,2.81116997 7.91882991,2.97718102 Z M16.3130714,2.61969703 C16.5468915,2.70945218 16.6867491,2.92636571 16.6550618,3.12945351 L16.6349864,3.204688 L15.8291874,5.30386631 C15.7439285,5.52597336 15.4615702,5.62417066 15.1985225,5.52319612 C14.9647024,5.43344097 14.8248448,5.21652743 14.8565321,5.01343963 L14.8766075,4.93820515 L15.6824065,2.83902684 C15.7676654,2.61691979 16.0500237,2.51872249 16.3130714,2.61969703 Z"
        id="sun"
        className="theme-icon sun"
      />
    </Fragment>
  ),
});

export const IconView = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <circle cx="12" cy="12" r="2"></circle>
    <path d="M22 12c-2.667 4.667 -6 7 -10 7s-7.333 -2.333 -10 -7c2.667 -4.667 6 -7 10 -7s7.333 2.333 10 7"></path>
  </IconBox>
);

export const IconViewOff = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <line x1="3" y1="3" x2="21" y2="21"></line>
    <path d="M10.584 10.587a2 2 0 0 0 2.828 2.83"></path>
    <path d="M9.363 5.365a9.466 9.466 0 0 1 2.637 -.365c4 0 7.333 2.333 10 7c-.778 1.361 -1.612 2.524 -2.503 3.488m-2.14 1.861c-1.631 1.1 -3.415 1.651 -5.357 1.651c-4 0 -7.333 -2.333 -10 -7c1.369 -2.395 2.913 -4.175 4.632 -5.341"></path>
  </IconBox>
);

export const IconOverview = (props: IconProps) => (
  <IconBox
    props={{
      ...props,
      viewBox: "0 0 19 12",
      strokeWidth: 0,
      fill: "currentColor",
    }}
  >
    <path d="M1.29545 12C0.95 12 0.647727 11.8714 0.388636 11.6143C0.129545 11.3571 0 11.0571 0 10.7143V1.28571C0 0.942857 0.129545 0.642857 0.388636 0.385714C0.647727 0.128571 0.95 0 1.29545 0H10.7955C11.1409 0 11.4432 0.128571 11.7023 0.385714C11.9614 0.642857 12.0909 0.942857 12.0909 1.28571V10.7143C12.0909 11.0571 11.9614 11.3571 11.7023 11.6143C11.4432 11.8714 11.1409 12 10.7955 12H1.29545ZM1.29545 10.7143H10.7955V1.28571H1.29545V10.7143ZM14.25 12V0H15.5455V12H14.25ZM17.7045 12V0H19V12H17.7045Z" />
  </IconBox>
);

export const IconGauge = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <circle cx="12" cy="12" r="9"></circle>
    <circle cx="12" cy="12" r="1"></circle>
    <line x1="13.41" y1="10.59" x2="16" y2="8"></line>
    <path d="M7 12a5 5 0 0 1 5 -5"></path>
  </IconBox>
);

export const IconAssessmentReport = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
    <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"></path>
    <line x1="9" y1="17" x2="9" y2="12"></line>
    <line x1="12" y1="17" x2="12" y2="16"></line>
    <line x1="15" y1="17" x2="15" y2="14"></line>
  </IconBox>
);

export const IconUsers = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    <path d="M21 21v-2a4 4 0 0 0 -3 -3.85"></path>
  </IconBox>
);

export const IconTraining = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M22 9l-10 -4l-10 4l10 4l10 -4v6"></path>
    <path d="M6 10.6v5.4a6 3 0 0 0 12 0v-5.4"></path>
  </IconBox>
);

<svg
  xmlns="http://www.w3.org/2000/svg"
  className="icon icon-tabler icon-tabler-school"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  stroke-width="2"
  stroke="currentColor"
  fill="none"
  stroke-linecap="round"
  stroke-linejoin="round"
></svg>;

export const IconMessaging = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M8 9h8"></path>
    <path d="M8 13h6"></path>
    <path d="M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z"></path>
  </IconBox>
);

export const IconSettings = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <circle cx="14" cy="6" r="2"></circle>
    <line x1="4" y1="6" x2="12" y2="6"></line>
    <line x1="16" y1="6" x2="20" y2="6"></line>
    <circle cx="8" cy="12" r="2"></circle>
    <line x1="4" y1="12" x2="6" y2="12"></line>
    <line x1="10" y1="12" x2="20" y2="12"></line>
    <circle cx="17" cy="18" r="2"></circle>
    <line x1="4" y1="18" x2="15" y2="18"></line>
    <line x1="19" y1="18" x2="20" y2="18"></line>
  </IconBox>
);

export const IconPowerUser = createIcon({
  viewBox: "0 0 24 24",
  path: (
    <path
      d="M23,14 L20.1961508,17.1809814 L23,17.1809814 C17.6666667,21.7269938 15,24 15,24 C15,24 16.090617,22.0795441 18.2718509,18.2386324 L15.5689814,18.2386324 L19.0891201,14 L23,14 Z M11.2797152,12 C12.7120495,12 14.1050772,12.2856672 15.3910602,12.8320773 C15.8993638,13.0480539 16.1363417,13.635199 15.9203651,14.1435026 C15.7043885,14.6518062 15.1172434,14.8887841 14.6089398,14.6728075 C13.56946,14.2311358 12.442349,14 11.2797152,14 C6.70022155,14 3,17.5886871 3,22 C3,22.5522847 2.55228475,23 2,23 C1.44771525,23 1,22.5522847 1,22 C1,16.4701874 5.60911845,12 11.2797152,12 Z M13.5,0 C16.5375661,0 19,2.46243388 19,5.5 C19,8.53756612 16.5375661,11 13.5,11 C10.4624339,11 8,8.53756612 8,5.5 C8,2.46243388 10.4624339,0 13.5,0 Z M13.5,2 C11.5670034,2 10,3.56700338 10,5.5 C10,7.43299662 11.5670034,9 13.5,9 C15.4329966,9 17,7.43299662 17,5.5 C17,3.56700338 15.4329966,2 13.5,2 Z"
      fill="currentColor"
    />
  ),
});

export const IconExit = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"></path>
    <path d="M7 12h14l-3 -3m0 6l3 -3"></path>
  </IconBox>
);

export const IconAccountSettings = createIcon({
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        d="M10.2797152,12 C11.7120495,12 13.1050772,12.2856672 14.3910602,12.8320773 C14.8993638,13.0480539 15.1363417,13.635199 14.9203651,14.1435026 C14.7043885,14.6518062 14.1172434,14.8887841 13.6089398,14.6728075 C12.56946,14.2311358 11.442349,14 10.2797152,14 C5.70022155,14 2,17.5886871 2,22 C2,22.5522847 1.55228475,23 1,23 C0.44771525,23 4.4408921e-14,22.5522847 4.4408921e-14,22 C4.4408921e-14,16.4701874 4.60911845,12 10.2797152,12 Z M7.5,0 C10.5375661,0 13,2.46243388 13,5.5 C13,8.53756612 10.5375661,11 7.5,11 C4.46243388,11 2,8.53756612 2,5.5 C2,2.46243388 4.46243388,0 7.5,0 Z M7.5,2 C5.56700338,2 4,3.56700338 4,5.5 C4,7.43299662 5.56700338,9 7.5,9 C9.43299662,9 11,7.43299662 11,5.5 C11,3.56700338 9.43299662,2 7.5,2 Z"
        fill="currentColor"
      />
      <path
        d="M19.1882102,14 L19.1886521,15.6278745 C19.5930339,15.7293472 19.9702715,15.8992215 20.307351,16.1244837 L21.5333093,15.1319377 L22.7919501,16.6862296 L21.5985299,17.6536334 C21.7719558,18.0420751 21.8785861,18.4668818 21.9038208,18.9134535 L23.3764205,19.2536471 L22.9265184,21.2023872 L21.4596006,20.8640572 C21.2470484,21.2470858 20.9666619,21.5872709 20.6346659,21.8683877 L21.3023493,23.2377796 L19.5047612,24.1145219 L18.8066081,22.6857681 C18.6441604,22.7081994 18.4782515,22.7197917 18.3096351,22.7197917 C18.0622022,22.7197917 17.8205996,22.6948292 17.5872083,22.6472852 L16.8716593,24.1145219 L15.0740712,23.2377796 L15.8166141,21.7168824 C15.5438264,21.454959 15.3122166,21.1504725 15.1324627,20.8141008 L13.4499021,21.2023872 L13,19.2536471 L14.7191489,18.8560517 C14.7459552,18.4858353 14.8287458,18.1311397 14.9590956,17.8003902 L13.5844704,16.6862296 L14.8431112,15.1319377 L16.181708,16.2157134 C16.4846326,15.9933738 16.8236241,15.8172894 17.1882749,15.6978679 L17.1882102,14 L19.1882102,14 Z M18.3096351,17.5197917 C17.4259795,17.5197917 16.7096351,18.2361361 16.7096351,19.1197917 C16.7096351,20.0034473 17.4259795,20.7197917 18.3096351,20.7197917 C19.1932907,20.7197917 19.9096351,20.0034473 19.9096351,19.1197917 C19.9096351,18.2361361 19.1932907,17.5197917 18.3096351,17.5197917 Z"
        fill="currentColor"
      />
    </g>
  ),
});

export const IconChevronDown = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <polyline points="6 9 12 15 18 9"></polyline>
  </IconBox>
);

export const IconChevronUp = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <polyline points="6 15 12 9 18 15"></polyline>
  </IconBox>
);

export const IconFilter = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M5.5 5h13a1 1 0 0 1 .5 1.5l-5 5.5l0 7l-4 -3l0 -4l-5 -5.5a1 1 0 0 1 .5 -1.5"></path>
  </IconBox>
);

export const IconFilterRemove = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <line x1="3" y1="3" x2="21" y2="21"></line>
    <path d="M9 5h9.5a1 1 0 0 1 .5 1.5l-4.049 4.454m-.951 3.046v5l-4 -3v-4l-5 -5.5a1 1 0 0 1 .18 -1.316"></path>
  </IconBox>
);

export const IconMenu = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <line x1="4" y1="6" x2="20" y2="6"></line>
    <line x1="4" y1="12" x2="20" y2="12"></line>
    <line x1="4" y1="18" x2="20" y2="18"></line>
  </IconBox>
);

export const IconVideo = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z"></path>
    <rect x="3" y="6" width="12" height="12" rx="2"></rect>
  </IconBox>
);

// export const IconBenchmark = createIcon({
//   displayName: "Benchmark",
//   viewBox: "0 0 24 24",
//   path: (
//     <g fill="currentColor" fillRule="nonzero">
//       <path
//         d="M12,3 L13.5337163,6.88902066 L17.7063391,7.14589803 L14.481605,9.80632236 L15.5267115,13.854102 L12,11.609314 L8.47328849,13.854102 L9.51839495,9.80632236 L6.2936609,7.14589803 L10.4662837,6.88902066 L12,3 Z M12.4885857,8.32751951 L12,7.088 L11.5114143,8.32751951 L10.181,8.409 L11.2094518,9.25686469 L10.876,10.545 L12,9.8312316 L13.123,10.545 L12.7905482,9.25686469 L13.818,8.409 L12.4885857,8.32751951 Z"
//         id="star"
//       />
//       <path
//         d="M12,0 C16.9705627,0 21,4.02943725 21,9 C21,11.8164965 19.706246,14.3308206 17.6806031,15.981107 L17.6808815,23.9917271 L12.381,21.759 L7.08275934,23.9917271 L7.08162999,16.538453 C4.62392235,14.9316807 3,12.1554841 3,9 C3,4.02943725 7.02943725,0 12,0 Z M12,18 C10.7901205,18 9.63600079,17.7612642 8.58217878,17.3283307 L8.582,21.731 L12.3818204,20.1312349 L16.18,21.731 L16.1801745,16.9723923 C14.9311117,17.6286647 13.5089208,18 12,18 Z M12,1.5 C7.85786438,1.5 4.5,4.85786438 4.5,9 C4.5,13.1421356 7.85786438,16.5 12,16.5 C16.1421356,16.5 19.5,13.1421356 19.5,9 C19.5,4.85786438 16.1421356,1.5 12,1.5 Z"
//         id="badge"
//       />
//     </g>
//   ),
// });

export const IconBenchmark = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"></path>
    <path d="M9 12l2 2l4 -4"></path>
  </IconBox>
);

export const IconVideoAlt = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <rect x="3" y="5" width="18" height="14" rx="4"></rect>
    <path d="M10 9l5 3l-5 3z"></path>
  </IconBox>
);

export const IconArchive = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <rect x="3" y="4" width="18" height="4" rx="2"></rect>
    <path d="M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-10"></path>
    <line x1="10" y1="12" x2="14" y2="12"></line>
  </IconBox>
);

export const IconEdit = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4"></path>
    <line x1="13.5" y1="6.5" x2="17.5" y2="10.5"></line>
  </IconBox>
);

export const IconQuestionMark = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M8 8a3.5 3 0 0 1 3.5 -3h1a3.5 3 0 0 1 3.5 3a3 3 0 0 1 -2 3a3 4 0 0 0 -2 4"></path>
    <line x1="12" y1="19" x2="12" y2="19.01"></line>
  </IconBox>
);

export const IconSort = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M3 9l4 -4l4 4m-4 -4v14"></path>
    <path d="M21 15l-4 4l-4 -4m4 4v-14"></path>
  </IconBox>
);

export const IconNumber = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <line x1="5" y1="9" x2="19" y2="9"></line>
    <line x1="5" y1="15" x2="19" y2="15"></line>
    <line x1="11" y1="4" x2="7" y2="20"></line>
    <line x1="17" y1="4" x2="13" y2="20"></line>
  </IconBox>
);

export const IconCalendar = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <rect x="4" y="5" width="16" height="16" rx="2"></rect>
    <line x1="16" y1="3" x2="16" y2="7"></line>
    <line x1="8" y1="3" x2="8" y2="7"></line>
    <line x1="4" y1="11" x2="20" y2="11"></line>
    <line x1="11" y1="15" x2="12" y2="15"></line>
    <line x1="12" y1="15" x2="12" y2="18"></line>
  </IconBox>
);

export const IconSearch = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <circle cx="10" cy="10" r="7"></circle>
    <line x1="21" y1="21" x2="15" y2="15"></line>
  </IconBox>
);

export const IconCross = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </IconBox>
);

export const IconExclamation = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <circle cx="12" cy="12" r="9"></circle>
    <line x1="12" y1="8" x2="12" y2="12"></line>
    <line x1="12" y1="16" x2="12.01" y2="16"></line>
  </IconBox>
);

export const IconTip = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7"></path>
    <path d="M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0 -1 3a2 2 0 0 1 -4 0a3.5 3.5 0 0 0 -1 -3"></path>
    <line x1="9.7" y1="17" x2="14.3" y2="17"></line>
  </IconBox>
);

export const IconTrash = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <line x1="4" y1="7" x2="20" y2="7"></line>
    <line x1="10" y1="11" x2="10" y2="17"></line>
    <line x1="14" y1="11" x2="14" y2="17"></line>
    <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
    <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
  </IconBox>
);

export const IconOverflowMenu = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <circle cx="12" cy="12" r="1"></circle>
    <circle cx="12" cy="19" r="1"></circle>
    <circle cx="12" cy="5" r="1"></circle>
  </IconBox>
);

export const IconExport = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
    <path d="M11.5 21h-4.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v5m-5 6h7m-3 -3l3 3l-3 3"></path>
  </IconBox>
);

export const IconDashed = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M5 12h2"></path>
    <path d="M17 12h2"></path>
    <path d="M11 12h2"></path>
  </IconBox>
);

export const IconMaximize = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M4 8v-2a2 2 0 0 1 2 -2h2"></path>
    <path d="M4 16v2a2 2 0 0 0 2 2h2"></path>
    <path d="M16 4h2a2 2 0 0 1 2 2v2"></path>
    <path d="M16 20h2a2 2 0 0 0 2 -2v-2"></path>
  </IconBox>
);

export const IconMinimize = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M15 19v-2a2 2 0 0 1 2 -2h2"></path>
    <path d="M15 5v2a2 2 0 0 0 2 2h2"></path>
    <path d="M5 15h2a2 2 0 0 1 2 2v2"></path>
    <path d="M5 9h2a2 2 0 0 0 2 -2v-2"></path>
  </IconBox>
);

export const IconFlag = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M5 14h14l-4.5 -4.5l4.5 -4.5h-14v16"></path>
  </IconBox>
);

export const IconVideoPlay = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M7 4v16l13 -8z"></path>
  </IconBox>
);

export const IconVideoPause = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <rect x="6" y="5" width="4" height="14" rx="1"></rect>
    <rect x="14" y="5" width="4" height="14" rx="1"></rect>
  </IconBox>
);

export const IconVolumeMute = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a0.8 .8 0 0 1 1.5 .5v14a0.8 .8 0 0 1 -1.5 .5l-3.5 -4.5"></path>
    <path d="M16 10l4 4m0 -4l-4 4"></path>
  </IconBox>
);

export const IconVolume = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M15 8a5 5 0 0 1 0 8"></path>
    <path d="M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a0.8 .8 0 0 1 1.5 .5v14a0.8 .8 0 0 1 -1.5 .5l-3.5 -4.5"></path>
  </IconBox>
);

export const IconCog = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </IconBox>
);

export const IconScatterChart = createIcon({
  viewBox: "0 0 24 24",
  path: (
    <g fill={"currentColor"}>
      <path d="M4 21h17v-2H5V3H3v17a1 1 0 0 0 1 1z" />
      <circle cx="10" cy="8" r="2" />
      <circle cx="18" cy="12" r="2" />
      <circle cx="11.5" cy="13.5" r="1.5" />
      <circle cx="16.5" cy="6.5" r="1.5" />
    </g>
  ),
});

export const IconBuilding = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M8 9l5 5v7h-5v-4m0 4h-5v-7l5 -5m1 1v-6a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v17h-8"></path>
    <line x1="13" y1="7" x2="13" y2="7.01"></line>
    <line x1="17" y1="7" x2="17" y2="7.01"></line>
    <line x1="17" y1="11" x2="17" y2="11.01"></line>
    <line x1="17" y1="15" x2="17" y2="15.01"></line>
  </IconBox>
);

export const IconPieChart = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M12 3v9h9"></path>
    <circle cx="12" cy="12" r="9"></circle>
  </IconBox>
);

export const IconDetail = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <rect x="3" y="4" width="18" height="16" rx="2"></rect>
    <path d="M7 8h10"></path>
    <path d="M7 12h10"></path>
    <path d="M7 16h10"></path>
  </IconBox>
);

export const IconImage = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <line x1="15" y1="8" x2="15.01" y2="8"></line>
    <rect x="4" y="4" width="16" height="16" rx="3"></rect>
    <path d="M4 15l4 -4a3 5 0 0 1 3 0l5 5"></path>
    <path d="M14 14l1 -1a3 5 0 0 1 3 0l2 2"></path>
  </IconBox>
);

export const IconBell = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"></path>
    <path d="M9 17v1a3 3 0 0 0 6 0v-1"></path>
  </IconBox>
);

export const IconUserAccounts = createIcon({
  viewBox: "0 0 24 24",
  path: (
    <g fill={"currentColor"}>
      <path d="M20 2H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-6 2.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM19 15H9v-.25C9 12.901 11.254 11 14 11s5 1.901 5 3.75V15z" />
      <path d="M4 8H2v12c0 1.103.897 2 2 2h12v-2H4V8z" />
    </g>
  ),
});

export const IconEmptyList = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M19 8h-14"></path>
    <path d="M5 12h7"></path>
    <path d="M12 16h-7"></path>
    <path d="M16 14l4 4"></path>
    <path d="M20 14l-4 4"></path>
  </IconBox>
);

export const IconErrorFace = (props: IconProps) => (
  <IconBox props={{ ...props, viewBox: "0 0 72 72" }}>
    <g
      transform="translate(5.000000, 5.000000)"
      fill="currentColor"
      fillRule="nonzero"
    >
      <path d="M31.5,0 C48.8969696,0 63,14.1030304 63,31.5 C63,48.8969696 48.8969696,63 31.5,63 C14.1030304,63 0,48.8969696 0,31.5 C0,14.1030304 14.1030304,0 31.5,0 Z M31.5,1.75 C15.0695287,1.75 1.75,15.0695287 1.75,31.5 C1.75,47.9304713 15.0695287,61.25 31.5,61.25 C47.9304713,61.25 61.25,47.9304713 61.25,31.5 C61.25,15.0695287 47.9304713,1.75 31.5,1.75 Z M32.3219167,33.5416667 C38.0418997,33.5416667 43.6548738,34.9362065 49.1519865,37.7193508 C49.5831271,37.9376339 49.7556822,38.4640958 49.5373992,38.8952365 C49.3191161,39.3263771 48.7926542,39.4989322 48.3615135,39.2806492 C47.4513837,38.8198577 46.5386646,38.3990523 45.623304,38.0181995 L45.6554367,38.1944695 C46.4566829,42.6755331 46.1567419,45.6160169 44.5779683,47.0567741 C42.0189782,49.3931167 38.8545023,49.2976899 36.3643709,46.4919348 C34.9365776,44.8825314 34.3145012,42.1213759 34.4299267,38.1888372 L34.4514258,37.6190752 C34.4779271,37.0413405 34.5194131,36.4396808 34.5756851,35.8140391 L34.6050523,35.4992194 L36.3469477,35.6674472 C36.2982469,36.1717138 36.2595444,36.6581824 36.2307101,37.1268163 L36.2008373,37.680614 L36.180388,38.2172764 L36.1693121,38.7367893 C36.1287417,41.972702 36.6491335,44.1759454 37.6733482,45.3304365 C39.5034604,47.3925151 41.5472483,47.4541468 43.3981777,45.7642594 C44.3951648,44.8544289 44.6314641,42.4192841 43.9321235,38.5000096 L43.8355847,37.9803866 L43.7833087,37.7142691 L44.4972968,37.57036 C40.4910548,36.0503014 36.4340445,35.2916667 32.3219167,35.2916667 C26.8817145,35.2916667 21.538552,36.6191719 16.2823539,39.2806319 C15.8512228,39.4989338 15.3247534,39.3264017 15.1064514,38.8952706 C14.8881495,38.4641395 15.0606816,37.93767 15.4918127,37.7193681 C20.9883563,34.9362099 26.6013444,33.5416667 32.3219167,33.5416667 Z M40.8333333,37.0416667 C41.2881561,37.0416667 41.6619284,37.3886847 41.7043278,37.8323983 L41.7083333,37.9166667 L41.7083333,43.1666667 C41.7083333,43.6499158 41.3165825,44.0416667 40.8333333,44.0416667 C40.3785106,44.0416667 40.0047383,43.6946486 39.9623388,43.250935 L39.9583333,43.1666667 L39.9583333,37.9166667 C39.9583333,37.4334175 40.3500842,37.0416667 40.8333333,37.0416667 Z M18.0133333,16.3625 L21.091,19.624 L24.1698333,16.3625 L25.4671667,17.7374167 L22.389,20.999 L25.4671667,24.2625833 L24.1698333,25.6375 L21.091,22.375 L18.0133333,25.6375 L16.716,24.2625833 L19.793,21 L16.7148333,17.7374167 L18.01275,16.3625 L18.0133333,16.3625 Z M44.9866667,16.3625 L46.2845833,17.7374167 L43.206,20.999 L46.2851667,24.2625833 L44.98725,25.6375 L41.908,22.375 L38.8301667,25.6375 L37.5328333,24.2625833 L40.611,20.999 L37.53225,17.7374167 L38.8301667,16.3625 L41.908,19.624 L44.9866667,16.3625 Z" />
    </g>
  </IconBox>
);
export const IconBook = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M19 4v16h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12z"></path>
    <path d="M19 16h-12a2 2 0 0 0 -2 2"></path>
    <path d="M9 8h6"></path>
  </IconBox>
);
export const IconSortAscending = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M15 10v-5c0 -1.38 .62 -2 2 -2s2 .62 2 2v5m0 -3h-4"></path>
    <path d="M19 21h-4l4 -7h-4"></path>
    <path d="M4 15l3 3l3 -3"></path>
    <path d="M7 6v12"></path>
  </IconBox>
);

export const IconSortDescending = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M15 21v-5c0 -1.38 .62 -2 2 -2s2 .62 2 2v5m0 -3h-4"></path>
    <path d="M19 10h-4l4 -7h-4"></path>
    <path d="M4 15l3 3l3 -3"></path>
    <path d="M7 6v12"></path>
  </IconBox>
);
export const IconArrowDown = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="16" y1="15" x2="12" y2="19"></line>
    <line x1="8" y1="15" x2="12" y2="19"></line>
  </IconBox>
);
export const IconArrowUp = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="16" y1="9" x2="12" y2="5"></line>
    <line x1="8" y1="9" x2="12" y2="5"></line>
  </IconBox>
);
export const IconArrowLeft = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <line x1="5" y1="12" x2="19" y2="12"></line>
    <line x1="5" y1="12" x2="9" y2="16"></line>
    <line x1="5" y1="12" x2="9" y2="8"></line>
  </IconBox>
);
export const IconArrowRight = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <line x1="5" y1="12" x2="19" y2="12"></line>
    <line x1="15" y1="16" x2="19" y2="12"></line>
    <line x1="15" y1="8" x2="19" y2="12"></line>
  </IconBox>
);
export const IconNorthStar = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M3 12h18"></path>
    <path d="M12 21v-18"></path>
    <path d="M7.5 7.5l9 9"></path>
    <path d="M7.5 16.5l9 -9"></path>
  </IconBox>
);

export const IconCoach = (props: IconProps) => (
  <IconBox props={{ ...props, viewBox: "0 0 200 200" }}>
    <g fill="none" fillRule="evenodd" strokeWidth={0.3}>
      <path
        d="M200 100c0 55.226-44.774 100-100 100-33.519 0-63.188-16.496-81.332-41.81a99.788 99.788 0 01-11.055-19.858C2.707 126.527 0 113.579 0 100c0-5.32.414-10.542 1.22-15.637C8.721 36.563 50.092 0 100 0c55.226 0 100 44.774 100 100z"
        fill="#FC0"
        fillRule="nonzero"
      />
      <path
        d="M200 100.407a99.115 99.115 0 01-4.347 29.128C183.148 170.324 145.05 200 100 200c-25.766 0-49.258-9.706-66.988-25.656a99.765 99.765 0 01-24.508-33.691C3.035 128.348 0 114.732 0 100.407c0-6.768.676-13.374 1.968-19.766A98.749 98.749 0 0113.156 51C30.391 80.983 62.828 101.185 100 101.185S169.614 80.983 186.844 51C195.214 65.561 200 82.427 200 100.407z"
        fill="#FFDA46"
        fillRule="nonzero"
      />
      <path
        d="M12 148a99.084 99.084 0 009.657 14.491C39.978 185.344 68.263 200 100 200c31.737 0 60.022-14.656 78.343-37.509A99.084 99.084 0 00188 148H12z"
        fill="#FC0"
        fillRule="nonzero"
      />
      <path
        d="M176 165.291a99.976 99.976 0 01-22.763 19.51c-13.347 8.34-28.832 13.635-45.456 14.902l-7.002.292-.118.005h-1.325v-.005a102.859 102.859 0 01-7.117-.29h-.003c-16.624-1.269-32.104-6.565-45.451-14.907A99.818 99.818 0 0124 165.287l.898-4.972c2.938-16.236 16.725-28.246 33.173-29.246a35.34 35.34 0 012.231-.069h79.393c.75 0 1.49.023 2.23.07 16.449 1 30.236 13.009 33.174 29.245l.901 4.976z"
        fill="#D0F6FF"
        fillRule="nonzero"
      />
      <path
        d="M100 131v69h-.663v-.005a102.863 102.863 0 01-7.117-.29h-.003c-16.624-1.269-32.104-6.565-45.452-14.907A99.82 99.82 0 0124 165.287l.898-4.972c2.938-16.236 16.725-28.246 33.174-29.246a35.34 35.34 0 012.231-.069H100z"
        fill="#FFF"
        fillRule="nonzero"
      />
      <g fill="#E3835A" fillRule="nonzero">
        <path d="M139.62 71.37c4.949 0 8.96 3.983 8.96 8.893 0 8.946-7.307 16.197-16.322 16.197V71.351l7.361.02zM59.139 71.37c-4.949 0-8.961 3.983-8.961 8.893 0 8.946 7.307 16.197 16.322 16.197V71.351l-7.361.02zM81.959 90.932v39.286c0 9.546 7.797 17.288 17.421 17.288 9.618 0 17.422-7.742 17.422-17.288V90.932H81.96z" />
      </g>
      <path
        d="M83 91v39.582C83 140.199 90.609 148 100 148V91H83z"
        fill="#FFA87A"
        fillRule="nonzero"
      />
      <path
        d="M65 73.915V87.08c0 19.276 15.442 34.916 34.495 34.919h.007C118.548 122 134 106.362 134 87.08V73.916c0-1.983-.161-3.929-.484-5.82-2.25-13.602-12.278-24.535-25.292-27.975A34.335 34.335 0 0099.502 39h-.007c-3.016 0-5.942.39-8.725 1.128-13.014 3.432-23.032 14.365-25.284 27.967a34.75 34.75 0 00-.486 5.82z"
        fill="#FFA87A"
        fillRule="nonzero"
      />
      <path
        d="M65 73.916V87.08c0 19.277 15.668 34.916 35 34.919V39c-3.06 0-6.028.39-8.853 1.128-13.204 3.432-23.37 14.365-25.656 27.968a34.417 34.417 0 00-.491 5.82z"
        fill="#FFC0A4"
        fillRule="nonzero"
      />
      <path
        d="M115 81a4 4 0 11-8 0 4 4 0 018 0zM93 81a4 4 0 11-8 0 4 4 0 018 0z"
        fill="#323B5A"
        fillRule="nonzero"
      />
      <path
        d="M99.5 94c-1.38 0-2.5-1.211-2.5-2.705v-13.59C97 76.211 98.12 75 99.5 75s2.5 1.211 2.5 2.705v13.59c0 1.494-1.12 2.705-2.5 2.705z"
        fill="#E3835A"
        fillRule="nonzero"
      />
      <path
        d="M93.571 35h11.86C123.418 35 138 49.877 138 68.229v4.067L134.272 74l-7.542-7.694V55.642H72.271v10.664L64.728 74 61 72.296v-4.067C61 49.877 75.583 35 93.571 35z"
        fill="#323B5A"
        fillRule="nonzero"
      />
      <path
        d="M69 131v4.108C69 152.168 82.657 166 99.5 166c8.422 0 16.047-3.457 21.569-9.05 5.517-5.59 8.931-13.312 8.931-21.842V131H69z"
        fill="#FFA87A"
        fillRule="nonzero"
      />
      <path
        d="M69 131v4.108C69 152.168 82.881 166 100 166v-35H69zM59 131v21.035c0 12.337-4.12 24.255-11.614 33.965A102.442 102.442 0 0124 166.027l.922-5.09C27.94 144.317 42.104 132.023 59 131z"
        fill="#FFC0A4"
        fillRule="nonzero"
      />
      <path
        d="M176 166.03A102.596 102.596 0 01152.618 186C145.12 176.291 141 164.37 141 152.034V131c16.895 1.023 31.057 13.316 34.075 29.936l.925 5.093z"
        fill="#FFA87A"
        fillRule="nonzero"
      />
      <path
        fill="#323B5A"
        fillRule="nonzero"
        d="M133 131l-3.462 8.998-.004.008v.004l-4.238 11.025v.004l-18.712 48.664-7.117.292-.12.005H98v-.005l.674-1.747 13.786-35.86v-.004L124.53 131z"
      />
      <path
        d="M101 199.995V200h-1.348v-.005a106.24 106.24 0 01-7.233-.29h-.003L73.71 151.043l-.005-.012-4.238-11.02v-.004L66 131h8.47l12.07 31.384v.004l13.786 35.86.674 1.747z"
        fill="#323B5A"
        fillRule="nonzero"
      />
      <path
        d="M140 48.506v28.286a9.691 9.691 0 01-8.952-2.72l-1.232-1.267-.282-.287a14.38 14.38 0 00-10.246-4.319H80.712a14.39 14.39 0 00-9.36 3.48c-.308.263-.604.546-.89.839l-.283.287-1.23 1.268A9.68 9.68 0 0160 76.792V48.506C60 35.528 70.641 25 83.768 25h32.463C129.359 25 140 35.528 140 48.506z"
        fill="#D0F6FF"
        fillRule="nonzero"
      />
      <path
        d="M140 48.506v28.286a9.69 9.69 0 01-8.951-2.72l-1.233-1.267-.28-.287a14.377 14.377 0 00-10.245-4.319H100V25h16.232C129.36 25 140 35.528 140 48.506z"
        fill="#8FC9F7"
        fillRule="nonzero"
      />
      <path
        d="M128 48.014V71a14.355 14.355 0 00-8.571-2.867H80.576A14.359 14.359 0 0072 71V48.014C72 34.755 82.717 24 95.936 24h8.128C117.286 24 128 34.755 128 48.014z"
        fill="#FF3445"
        fillRule="nonzero"
      />
      <path
        d="M128 48.014V71a14.355 14.355 0 00-8.57-2.867H100V24h4.065C117.286 24 128 34.755 128 48.014z"
        fill="#BA0D5C"
        fillRule="nonzero"
      />
      <path
        d="M141.061 72.047c1.794 1.918.891 5.17-1.64 5.726l-.05.011c-3.138.686-6.533-.264-8.922-2.816l-1.23-1.312-.28-.298a14.322 14.322 0 00-1.73-1.566c-2.435-1.866-5.421-2.906-8.482-2.906H80.275c-3.065 0-6.05 1.04-8.487 2.906-.288.221-.568.454-.842.698-.308.272-.603.565-.888.868l-.281.298-1.228 1.312c-2.386 2.552-5.78 3.502-8.918 2.816-.016-.003-.033-.008-.051-.01-2.533-.558-3.436-3.812-1.64-5.73l.475-.508 1.216-1.297 3.493-3.733a23.819 23.819 0 017.822-5.54c.277-.118.562-.239.842-.347A23.221 23.221 0 0180.275 59h38.452c2.912 0 5.793.562 8.483 1.62.28.107.565.228.84.347a23.825 23.825 0 017.824 5.54l3.497 3.735 1.212 1.294.478.511z"
        fill="#474F6F"
        fillRule="nonzero"
      />
      <path
        d="M142.05 72.046c1.822 1.926.893 5.179-1.679 5.736a9.638 9.638 0 01-9.06-2.815l-1.24-1.31-.284-.301a14.314 14.314 0 00-.899-.869c-2.599-2.303-5.975-3.603-9.435-3.603H100V59h19.453c3.259 0 6.473.684 9.435 1.965a24.134 24.134 0 017.915 5.54l4.764 5.031.484.51z"
        fill="#323B5A"
        fillRule="nonzero"
      />
      <path
        d="M89 103c5.017 5.799 13.785 6.432 19.584 1.415.466-.403.905-.837 1.314-1.3L110 103h0"
        stroke="#E3835A"
        strokeWidth={3}
        strokeLinecap="round"
      />
    </g>
  </IconBox>
);
export const IconReset = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M15 4.55a8 8 0 0 0 -6 14.9m0 -4.45v5h-5" />
    <line x1="18.37" y1="7.16" x2="18.37" y2="7.17" />
    <line x1="13" y1="19.94" x2="13" y2="19.95" />
    <line x1="16.84" y1="18.37" x2="16.84" y2="18.38" />
    <line x1="19.37" y1="15.1" x2="19.37" y2="15.11" />
    <line x1="19.94" y1="11" x2="19.94" y2="11.01" />
  </IconBox>
);
export const IconLink = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M10 14a3.5 3.5 0 0 0 5 0l4 -4a3.5 3.5 0 0 0 -5 -5l-.5 .5" />
    <path d="M14 10a3.5 3.5 0 0 0 -5 0l-4 4a3.5 3.5 0 0 0 5 5l.5 -.5" />
  </IconBox>
);

export const IconDot = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <circle cx="12" cy="12" r="4" />
  </IconBox>
);

export const IconApps = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
    <path d="M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
    <path d="M14 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
    <path d="M14 7l6 0"></path>
    <path d="M17 4l0 6"></path>
  </IconBox>
);

export const IconLanguage = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M4 5h7"></path>
    <path d="M9 3v2c0 4.418 -2.239 8 -5 8"></path>
    <path d="M5 9c0 2.144 2.952 3.908 6.7 4"></path>
    <path d="M12 20l4 -9l4 9"></path>
    <path d="M19.1 18h-6.2"></path>
  </IconBox>
);

export const IconMerge = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M8 7l4 -4l4 4"></path>
    <path d="M12 3v5.394a6.737 6.737 0 0 1 -3 5.606a6.737 6.737 0 0 0 -3 5.606v1.394"></path>
    <path d="M12 3v5.394a6.737 6.737 0 0 0 3 5.606a6.737 6.737 0 0 1 3 5.606v1.394"></path>
  </IconBox>
);

export const IconMobileData = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M16 12v-8"></path>
    <path d="M8 20v-8"></path>
    <path d="M13 7l3 -3l3 3"></path>
    <path d="M5 17l3 3l3 -3"></path>
  </IconBox>
);

export const IconWiFi = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M12 18l.01 0"></path>
    <path d="M9.172 15.172a4 4 0 0 1 5.656 0"></path>
    <path d="M6.343 12.343a8 8 0 0 1 11.314 0"></path>
    <path d="M3.515 9.515c4.686 -4.687 12.284 -4.687 17 0"></path>
  </IconBox>
);

export const IconTextBold = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M7 5h6a3.5 3.5 0 0 1 0 7h-6z"></path>
    <path d="M13 12h1a3.5 3.5 0 0 1 0 7h-7v-7"></path>
  </IconBox>
);
export const IconTextItalic = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M11 5l6 0"></path>
    <path d="M7 19l6 0"></path>
    <path d="M14 5l-4 14"></path>
  </IconBox>
);

export const IconTextUnderline = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M7 5v5a5 5 0 0 0 10 0v-5"></path>
    <path d="M5 19h14"></path>
  </IconBox>
);
export const IconTextH1 = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M19 18v-8l-2 2"></path>
    <path d="M4 6v12"></path>
    <path d="M12 6v12"></path>
    <path d="M11 18h2"></path>
    <path d="M3 18h2"></path>
    <path d="M4 12h8"></path>
    <path d="M3 6h2"></path>
    <path d="M11 6h2"></path>
  </IconBox>
);
export const IconTextH2 = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M17 12a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0"></path>
    <path d="M4 6v12"></path>
    <path d="M12 6v12"></path>
    <path d="M11 18h2"></path>
    <path d="M3 18h2"></path>
    <path d="M4 12h8"></path>
    <path d="M3 6h2"></path>
    <path d="M11 6h2"></path>
  </IconBox>
);

export const IconTextQuote = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M10 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5"></path>
    <path d="M19 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5"></path>
  </IconBox>
);

export const IconTextBulletedList = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M9 6l11 0"></path>
    <path d="M9 12l11 0"></path>
    <path d="M9 18l11 0"></path>
    <path d="M5 6l0 .01"></path>
    <path d="M5 12l0 .01"></path>
    <path d="M5 18l0 .01"></path>
  </IconBox>
);

export const IconTextNumberedList = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M11 6h9"></path>
    <path d="M11 12h9"></path>
    <path d="M12 18h8"></path>
    <path d="M4 16a2 2 0 1 1 4 0c0 .591 -.5 1 -1 1.5l-3 2.5h4"></path>
    <path d="M6 10v-6l-2 2"></path>
  </IconBox>
);

export const IconAddressBook = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M20 6v12a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2z"></path>
    <path d="M10 16h6"></path>
    <path d="M13 11m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
    <path d="M4 8h3"></path>
    <path d="M4 12h3"></path>
    <path d="M4 16h3"></path>
  </IconBox>
);

export const IconSchoolBell = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M10 10m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0"></path>
    <path d="M13.5 15h.5a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-1a2 2 0 0 1 2 -2h.5"></path>
    <path d="M16 17a5.698 5.698 0 0 0 4.467 -7.932l-.467 -1.068"></path>
    <path d="M10 10v.01"></path>
    <path d="M20 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
  </IconBox>
);

export const IconClipboardList = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"></path>
    <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path>
    <path d="M9 12l.01 0"></path>
    <path d="M13 12l2 0"></path>
    <path d="M9 16l.01 0"></path>
    <path d="M13 16l2 0"></path>
  </IconBox>
);

export const IconHome = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M5 12l-2 0l9 -9l9 9l-2 0"></path>
    <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"></path>
    <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6"></path>
  </IconBox>
);

export const IconSwitch = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M16 3l4 4l-4 4" />
    <path d="M10 7l10 0" />
    <path d="M8 13l-4 4l4 4" />
    <path d="M4 17l9 0" />
  </IconBox>
);

export const IconHelp = (props: IconProps) => (
  <IconBox props={props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
    <path d="M12 17l0 .01" />
    <path d="M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4" />
  </IconBox>
);
